export const QUERY_KEYS = {
  AUTH: {
    ME: 'AUTH_ME',
  },
  GET_ROLES: 'GET_ROLES',
  GET_EMPLOYEES: 'GET_EMPLOYEES',
};
